import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './Components/Login';
import MainLayout from './Components/MainLayout';
import Dashboard from './Pages/Dashboard';
import UserManagement from './Pages/UserManagement';
import MyApps from './Pages/MyApps';
import CustomizableForms from './Pages/FormBuilder';
import Reports from './Pages/Reports';
import FillForms from './Pages/FillForms';
import CustomDashboard from './Pages/Formsdashboard';
import ChangePassword from './Components/ChangePassword';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();
  if (!token) return <Navigate to="/" replace />;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  // Force password change on first login (default password still in use)
  if (user.is_default_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

const SuperAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/" replace />;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!user.is_superadmin) return <Navigate to="/my-apps" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (token) return <Navigate to="/my-apps" replace />;
  return children;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Route */}
          <Route path="/" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />

          {/* Protected Routes */}
          <Route element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-management" element={<SuperAdminRoute><UserManagement /></SuperAdminRoute>} />
            <Route path="/my-apps" element={<MyApps />} />
            <Route path="/customizable-forms" element={<CustomizableForms />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/fill-forms" element={<FillForms />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/customizable-forms-dashboard" element={<CustomDashboard />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;